<template>
	<div class="container__model__preview">
		<div class="upper_preview">
			<h1 class="model__name">
				{{ model.stan_nm_titulo_modelo }}
			</h1>
			<div class="container__model_kpis">
				<KPI
					:value="
						model.stan_md_erro_porcentagem != null ? model.stan_md_erro_porcentagem.toFixed(3) : '-'
					"
					:description="`% ${$t('error')}`"
				/>
				<KPI
					:value="model.stan_md_erro != null ? model.stan_md_erro.toFixed(3) : '-'"
					:description="$t('error')"
				/>
				<KPI
					:value="
						model.stan_md_coeficiente_assimetria != null
							? model.stan_md_coeficiente_assimetria.toFixed(3)
							: '-'
					"
					:description="$t('asymmetry')"
				/>
				<KPI
					:value="
						model.stan_md_coeficiente_curtose != null
							? model.stan_md_coeficiente_curtose.toFixed(3)
							: '-'
					"
					:description="$t('kurtosis')"
				/>
			</div>
		</div>
		<div class="lower_preview">
			<div class="container__image">
				<RealEstimado
					:info-grafico="tipoInfoGrafico"
					class="main__parcels__chart"
					:series="model.graficosModelo.realEstimado"
				/>
				<Residuos
					:info-grafico="tipoInfoGrafico"
					class="main__parcels__chart"
					:series="model.graficosModelo.residuo"
				/>
				<Histogramas
					:info-grafico="tipoInfoGrafico"
					:y-titulo="$t('quantity')"
					:x-titulo="`Resíduos ${tipoInfoGrafico.unidade}`"
					:titulo="$t('residueHistogram')"
					class="main__parcels__chart"
					:series="model.graficosModelo.histograma.map((n) => n.x)"
				/>
			</div>
		</div>
		<slot />
	</div>
</template>

<script>
import KPI from '../KPI/KPI'
import Histogramas from '../Graficos/Histogramas'
import RealEstimado from '../Graficos/RealEstimado'
import Residuos from '../Graficos/Residuos'

export default {
	components: { KPI, Residuos, RealEstimado, Histogramas },
	props: {
		model: {
			type: Object,
			required: true,
		},

		tipoInfoGrafico: {
			type: Object,
			required: true,
		},
	},
}
</script>

<style scoped>
.container__model_kpis {
	display: flex;
	flex-direction: row;
	justify-content: space-evenly;
}

.model__name,
.model__modelo {
	color: #081f44;
	font-size: 26px;
	padding-bottom: 40px;
	text-align: center;
}

.container__model__preview {
	height: 90%;
	display: flex;
	flex-direction: column;
	/* justify-content: space-between; */
	/* max-height: 60vh;
  margin-bottom: 10rem; */
}

.container__image {
	display: flex;
	flex-direction: row;
	height: 100%;
	/* height: 100%; */
}

.lower_preview {
	height: 50vh;
}

@media screen and (min-device-width: 1200px) and (max-device-width: 1600px) and (-webkit-min-device-pixel-ratio: 1) {
	.container__model__preview {
		justify-content: none !important;
	}
}

@media screen and (max-width: 1370px) {
	.model__name,
	.model__modelo {
		color: #081f44;
		font-size: 18px;
		padding-bottom: 5px;
		padding-top: 5px;
		text-align: center;
	}
	.container__model_kpis {
		font-size: 0.2rem !important;
	}
}
img {
	height: 18rem;
	margin: 0 auto;
}
.container__cardgrafico.main__parcels__chart {
	height: 100%;
}
.cor {
	color: black !important;
}
</style>
